import * as types from "../../constants/actionsType";

const initialState = {
  addToCart: [],
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.ADD_TO_CART:
      let data = action.data;


      data = [action.data]


      return {
        ...state,
        addToCart: data,
      };
    case types.DELETE_CART:
      return {
        ...state,
        addToCart:
          state.addToCart.length == 0
            ? []
            : state.addToCart.filter((item) => item.id != action.payload),
      };
    case types.EMPTY_CART:
      return {
        ...state,
        addToCart: []
      };
    default:
      return state;
  }
};
export default reducer;
